import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, createVNode as _createVNode, Teleport as _Teleport, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b004af9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-search-wrapper" }
const _hoisted_2 = {
  id: "searchFormDrawerTitle",
  slot: "drawer-header"
}
const _hoisted_3 = { slot: "drawer-body" }

import {computed, ref} from 'vue';
    import {storeToRefs} from 'pinia';
    import {SearchPreviewTarget, useHeaderMenu} from '@/logged/features/header-menu';
    import HeaderSearchPreview from './HeaderSearchPreview.vue';
    import HeaderSearchForm from './HeaderSearchForm.vue';
    import {useDisplayMobile} from '@/logged/common/composables';
    import {useUser} from '@/logged/features/user';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderSearchWrapper',
  setup(__props) {

    const {isDisplayMobile} = useDisplayMobile();
    const headerMenuStore = useHeaderMenu();
    const {searchDisplayMode} = storeToRefs(headerMenuStore);
    const searchFormDrawer = ref<HTMLJoyDrawerElement | null>(null);
    const userStore = useUser();

    const searchPreviewVisible = computed(
        () => searchDisplayMode.value === 'PREVIEW' || (searchDisplayMode.value === 'FORM' && isDisplayMobile.value),
    );

    const searchFormVisible = computed(() => searchDisplayMode.value === 'FORM' && !isDisplayMobile.value);

    async function openSearchForm(target: SearchPreviewTarget) {
        headerMenuStore.setSearchDisplayModeToForm(target);
        if (isDisplayMobile.value) {
            await searchFormDrawer.value!.openDrawer();
        }
    }

    function goToPostAProject() {
        window.location.href = '/customer/searches/draft/dispatch?brief_origin=top_nav_global';
    }

return (_ctx: any,_cache: any) => {
  const _component_VJoyButton = _resolveComponent("VJoyButton")!
  const _component_joy_drawer = _resolveComponent("joy-drawer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (searchPreviewVisible.value)
      ? (_openBlock(), _createBlock(HeaderSearchPreview, {
          key: 0,
          onOpenSearchForm: openSearchForm
        }))
      : (searchFormVisible.value)
        ? (_openBlock(), _createBlock(HeaderSearchForm, { key: 1 }))
        : _createCommentVNode("", true),
    (searchFormVisible.value && _unref(userStore).hasSelectedClientIdentity)
      ? (_openBlock(), _createBlock(_component_VJoyButton, {
          key: 2,
          variant: "ghost",
          style: {"margin-left":"32px"},
          onClick: goToPostAProject
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$msg('navbar.aside.tabs.title.post.job.offer')), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_unref(isDisplayMobile))
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 3,
          to: "body",
          append: ""
        }, [
          _createVNode(_component_joy_drawer, {
            id: "searchFormDrawer",
            ref_key: "searchFormDrawer",
            ref: searchFormDrawer,
            "aria-labelledby": "searchFormDrawerTitle"
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$msg('navbar.header.search.dialog.title')), 1),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(HeaderSearchForm)
              ])
            ]),
            _: 1
          }, 512)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})